// Functions to switch / get element(s) attribute
export const disableElement = element => {
  if (element.length) {
    element.attr("disabled", true);
  }
};
export const enableElement = element => {
  if (element.length) {
    element.attr("disabled", false);
  }
};
